//Collection Accordion Script Handeling
function attachAccordionToggles() {
  // Add click handlers for headers
  document.querySelectorAll('.accordion-header, .accordion-subheader, .accordion-subsubheader').forEach(header => {
    header.addEventListener('click', function(e) {
      // Don't trigger if clicking the toggle or its label
      if (e.target.closest('.acc-toggle') || e.target.closest('.toggle-lbl')) return;
      
      const toggle = this.querySelector('.acc-toggle');
      if (toggle) {
        toggle.checked = !toggle.checked;
        toggle.dispatchEvent(new Event('change'));
      }
    });
  });

  // Simple click handler for favorites item
  document.querySelectorAll('.favorites-item .accordion-header').forEach(favoritesHeader => {
    favoritesHeader.addEventListener('click', function(e) {
      // Don't trigger if clicking the toggle or its label
      if (e.target.closest('.acc-toggle') || e.target.closest('.toggle-lbl')) return;
      
      const favoritesItem = this.closest('.favorites-item');
      favoritesItem.classList.toggle('accordion-open');
    });
  });

  // Master toggle functionality
  const masterToggle = document.getElementById('master-toggle');
  if (masterToggle) {
    masterToggle.addEventListener('change', function() {
      const allToggles = document.querySelectorAll('.accordion-header .acc-toggle, .accordion-subheader .acc-toggle, .accordion-subsubheader .acc-toggle');
      const allSubItems = document.querySelectorAll('.accordion-subitem');
      const allSubSubItems = document.querySelectorAll('.accordion-subsubitem');
      
      if (this.checked) {
        // When master toggle is checked, close all 2nd and 3rd level tabs
        allSubItems.forEach(item => {
          item.classList.remove('accordion-subopen');
          const toggle = item.querySelector('.acc-toggle');
          if (toggle) toggle.checked = false;
        });
        allSubSubItems.forEach(item => {
          item.classList.remove('accordion-subsubopen');
          const toggle = item.querySelector('.acc-toggle');
          if (toggle) toggle.checked = false;
        });
      } else {
        // When master toggle is unchecked, open all tabs and check all toggles
        allToggles.forEach(toggle => {
          toggle.checked = true;
        });
        allSubItems.forEach(item => {
          item.classList.add('accordion-subopen');
        });
        allSubSubItems.forEach(item => {
          item.classList.add('accordion-subsubopen');
        });
      }
      if (!window.location.pathname.includes('/collections/brands')) {
        updateProductCount();
      }
    });
  }

  // Toggle top-level sections (manufacturer)
  document
    .querySelectorAll(".accordion-header .acc-toggle")
    .forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        const accordionItem = checkbox.closest(".accordion-item");
        const subItems = accordionItem.querySelectorAll(".accordion-subitem");

        if (checkbox.checked) {
          accordionItem.classList.add("accordion-open");
        } else {
          accordionItem.classList.remove("accordion-open");
        }
        if (!window.location.pathname.includes('/collections/brands')) {
          updateProductCount();
        }
      });
    });

  // Toggle second-level sections (product type)
  document
    .querySelectorAll(".accordion-subheader .acc-toggle")
    .forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        const subItem = checkbox.closest(".accordion-subitem");
        const subSubItems = subItem.querySelectorAll(".accordion-subsubitem");
        const modelCheckboxes = subItem.querySelectorAll(
          ".accordion-subsubheader .acc-toggle"
        );

        if (checkbox.checked) {
          subItem.classList.add("accordion-subopen");
          modelCheckboxes.forEach(
            (modelCheckbox) => (modelCheckbox.checked = false)
          );
        } else {
          subItem.classList.remove("accordion-subopen");
          subSubItems.forEach((subSubItem) =>
            subSubItem.classList.remove("accordion-subsubopen")
          );
        }
        if (!window.location.pathname.includes('/collections/brands')) {
          updateProductCount();
        }
      });
    });

  // Toggle third-level sections (model)
  document
    .querySelectorAll(".accordion-subsubheader .acc-toggle")
    .forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        const subSubItem = checkbox.closest(".accordion-subsubitem");

        if (checkbox.checked) {
          subSubItem.classList.add("accordion-subsubopen");
        } else {
          subSubItem.classList.remove("accordion-subsubopen");
        }
        if (!window.location.pathname.includes('/collections/brands')) {
          updateProductCount();
        }
      });
    });
}

function attachOutOfStockToggle() {
  const toggle = document.getElementById('toggle-out-of-stock');
  const container = document.getElementById('ProductGridContainer');

  if (!toggle || !container) {
    console.log('Toggle or container missing');
    return;
  }

  // Check customer metafield preference first, then localStorage, then default to false
  let shouldShowOutOfStock = false;
  
  // Check if customer has a metafield preference
  if (window.customerOutOfStockPreference) {
    // Handle both array and string formats
    const preference = Array.isArray(window.customerOutOfStockPreference) 
      ? window.customerOutOfStockPreference[0] 
      : window.customerOutOfStockPreference;
    shouldShowOutOfStock = preference === 'Show';
  } else {
    // Fall back to localStorage preference
    const savedPreference = localStorage.getItem('showOutOfStock');
    shouldShowOutOfStock = savedPreference === 'true';
  }
  
  // Set initial state before any event listeners
  toggle.checked = shouldShowOutOfStock;
  
  if (shouldShowOutOfStock) {
    container.classList.remove('hide-sold-out');
    document.querySelectorAll('.no-products-message').forEach(message => {
      message.style.display = 'none';
    });
  } else {
    container.classList.add('hide-sold-out');
    // Show sold out messages immediately
    document.querySelectorAll('.accordion-subsubcontent').forEach(content => {
      const productItems = content.querySelectorAll('li.grid__item');
      const message = content.querySelector('.no-products-message');
      
      if (productItems.length > 0) {
        const allSoldOut = Array.from(productItems).every(item => item.classList.contains('sold-out'));
        message.style.display = allSoldOut ? 'flex' : 'none';
      }
    });
  }

  toggle.addEventListener('change', function () {
    // Save preference to localStorage (only if customer doesn't have a metafield preference)
    if (!window.customerOutOfStockPreference) {
      localStorage.setItem('showOutOfStock', this.checked);
    }
    
    if (this.checked) {
      container.classList.remove('hide-sold-out');
      document.querySelectorAll('.no-products-message').forEach(message => {
        message.style.display = 'none';
      });
    } else {
      container.classList.add('hide-sold-out');
      showSoldOutMessages();
    }

    runCombinedFilters?.();
    if (!window.location.pathname.includes('/collections/brands')) {
      updateProductCount?.();
    }
  });

  // Function to check and show messages for sold out sections
  function showSoldOutMessages() {
    document.querySelectorAll('.accordion-subsubcontent').forEach(content => {
      const productItems = content.querySelectorAll('li.grid__item');
      const message = content.querySelector('.no-products-message');
      
      if (productItems.length > 0) {
        const allSoldOut = Array.from(productItems).every(item => item.classList.contains('sold-out'));
        message.style.display = allSoldOut ? 'flex' : 'none';
      }
    });
  }
}

//Toggle list view
function setupViewToggle() {
  const viewToggle = document.querySelector('.view-toggle');
  if (!viewToggle || viewToggle.dataset.viewToggleInitialized) return;

  const gridViewBtn = viewToggle.querySelector('.grid-view');
  const listViewBtn = viewToggle.querySelector('.list-view');
  const productGrids = document.querySelectorAll('.product-grid, .collection-quick-add-bulk');
  if (productGrids.length === 0) return;

  viewToggle.dataset.viewToggleInitialized = 'true';

  // Always check reduce_images first, on all screen sizes
  if (window.customerReduceImages === true) {
    productGrids.forEach(grid => grid.classList.remove('list-view'));
    grid.classList.add('reduced-images');
    gridViewBtn.classList.add('active');
    listViewBtn.classList.remove('active');
    listViewBtn.disabled = true;
    listViewBtn.style.opacity = '0.5';
    listViewBtn.style.cursor = 'not-allowed';
    return;
  }

  function isSmallScreen() {
    return window.innerWidth <= 749;
  }

  function getCustomerPreference() {
    let viewPref = window.customerDefaultProductView;
    if (Array.isArray(viewPref)) return viewPref[0];
    return viewPref;
  }

  if (isSmallScreen()) {
    let preferredView = 'grid';
    const customerPref = getCustomerPreference();
    if (customerPref && typeof customerPref === 'string' && customerPref.trim() !== '') {
      preferredView = customerPref.toLowerCase();
    } else {
      const savedView = localStorage.getItem('productViewPreference');
      if (savedView) preferredView = savedView;
    }

    if (preferredView === 'list') {
      productGrids.forEach(grid => grid.classList.add('list-view'));
      gridViewBtn.classList.remove('active');
      listViewBtn.classList.add('active');
    } else {
      productGrids.forEach(grid => grid.classList.remove('list-view'));
      gridViewBtn.classList.add('active');
      listViewBtn.classList.remove('active');
    }
  }

  gridViewBtn.addEventListener('click', function() {
    productGrids.forEach(grid => grid.classList.remove('list-view'));
    gridViewBtn.classList.add('active');
    listViewBtn.classList.remove('active');
    if (isSmallScreen()) {
      const customerPref = getCustomerPreference();
      if (!customerPref || typeof customerPref !== 'string' || customerPref.trim() === '') {
        localStorage.setItem('productViewPreference', 'grid');
      }
    }
  });

  listViewBtn.addEventListener('click', function() {
    productGrids.forEach(grid => grid.classList.add('list-view'));
    gridViewBtn.classList.remove('active');
    listViewBtn.classList.add('active');
    if (isSmallScreen()) {
      const customerPref = getCustomerPreference();
      if (!customerPref || typeof customerPref !== 'string' || customerPref.trim() === '') {
        localStorage.setItem('productViewPreference', 'list');
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const accordionContainer = document.getElementById('accordion-container');
  if (accordionContainer) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          if (accordionContainer.querySelector('.product-grid')) {
            setupViewToggle();
            observer.disconnect();
            break;
          }
        }
      }
    });
    observer.observe(accordionContainer, { childList: true, subtree: true });
    setupViewToggle();
  } else {
    setupViewToggle();
  }
});

